'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _d = require('d3');

exports.default = function (container, scales, configuration) {
    return function (data) {
        /*const leftOffset = configuration.labelsWidth +
            configuration.labelsRightMargin;*/

        var shapeLines = container.selectAll('.shape-line').data(data).enter().append('g').classed('shape-line', true).attr('width', scales.x.range()[1]).attr('transform', function (d, idx) {
            return 'translate(0, ' + scales.y(idx) + ')';
        });

        var shapes = shapeLines.selectAll('.shape');
        shapes.data(function (d) {
            return d.data;
        }).enter().filter(function (d) {
            if (d.shape) {
                return d;
            }return false;
        }).append('path').attr('d', (0, _d.symbol)().size(140).type(_d.symbolStar)).attr('fill', function (d) {
            return configuration.shapes[d.shape].fill;
        }).classed('shape', true).attr('stroke', 'white').attr('stroke-width', 1).attr('data-id', function (d) {
            return d.id;
        }).attr('transform', function (d, idx) {
            return 'translate(' + scales.x(configuration.date(d)) + ',' + configuration.shapes[d.shape].offsetY + ')';
        }).on('mousedown', configuration.click).on('dblclick', configuration.dblclick).on('mouseover', configuration.mouseover).on('mouseout', configuration.mouseout);

        shapes.exit().on('mousedown', null).on('dblclick', null).on('mouseout', null).on('mouseover', null).remove();

        shapeLines.exit().remove();
        // unregister previous event handlers to prevent from memory leaks
    };
};
//# sourceMappingURL=shapes.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/drawer/shapes.js
// module id = ../../../../ansyn-event-drops/dist-es5/drawer/shapes.js
// module chunks = vendor